import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MyPayments from "./mypayments";
import Footer from "./Footer";
const UserPayments = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <MyPayments />
      <Footer />
    </>
  );
};

export default UserPayments;
